module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.718 16.692l-6.7 7.014a.94.94 0 0 1-1.368 0l-1.368-1.434a1.046 1.046 0 0 1 0-1.432l4.644-4.868-4.586-4.81a1.043 1.043 0 0 1 0-1.43l1.368-1.434a.933.933 0 0 1 1.368 0l6.644 6.958a1.057 1.057 0 0 1-.002 1.436z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/right-circle-2.js
// module id = 1386
// module chunks = 14